import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { pinSetupValidators } from "../../../lib/validations/authValidations";

export const useActivationWizardForm = () => {
  const [step, setStep] = useState(1);

  const { control, handleSubmit, watch, trigger } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
      newPin: "",
      confirmPin: "",
    },
    mode: "onTouched",
  });

  const password = watch("password");
  const confirmPassword = watch("confirmPassword");
  const newPin = watch("newPin");
  const confirmPin = watch("confirmPin");

  const passwordValidations = useMemo(
    () => [
      {
        label: "At least 8 characters",
        valid: password.length >= 8,
      },
      {
        label: "Both passwords must match",
        valid: password === confirmPassword && confirmPassword.length > 0,
      },
      {
        label: "At least 1 uppercase & lowercase letter",
        valid: /[A-Z]/.test(password) && /[a-z]/.test(password),
      },
      {
        label: "At least 1 number & 1 special character",
        valid: /\d/.test(password) && /[!@#$%^&*(),.?":{}|<>]/.test(password),
      },
    ],
    [password, confirmPassword],
  );

  const isStep1Valid = passwordValidations.every((rule) => rule.valid);
  const isStep2Valid =
    !pinSetupValidators.newPin(newPin) &&
    !pinSetupValidators.confirmPin(newPin, confirmPin);

  const goToStep2 = async () => {
    const isValid = await trigger(["password", "confirmPassword"]);
    if (isValid) setStep(2);
  };

  const goToStep1 = () => setStep(1);

  return {
    step,
    goToStep2,
    goToStep1,
    control,
    handleSubmit,
    passwordValidations,
    isStep1Valid,
    isStep2Valid,
  };
};
